// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </AuthProvider>
);

if ('serviceWorker' in navigator && 'PushManager' in window) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js');
      console.log('🛠 Service Worker registered', registration);

      // Subscribe user to push
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(
          "BGSPUWZSNc017b3b6_Ue4N6UGgk42YtxmgKvD7rMeXLM1xdmThEVHdaYyfY1AdZS6g_5Y60Rfj9ukpnIHtlSWWM"
        ),
      });

      console.log('📬 Push Subscription', JSON.stringify(subscription));

      // Send to your backend to save the subscription
      await fetch(`${process.env.REACT_APP_API_BASE}/app/API/rbmgt/chat/savePushSubscription.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(subscription),
      });

    } catch (error) {
      console.error('🚫 Push subscription error:', error);
    }
  });
}

// Helper: Convert VAPID key to Uint8Array
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  return Uint8Array.from([...raw].map(char => char.charCodeAt(0)));
}
